// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const uk: ChromeTranslations = {
  'nav.nextPage': 'наступна сторінка →',
  'nav.previousPage': '← попередня сторінка',
  'nav.continueToLevel': 'продовжити до рівня →',
  'nav.backToMenu': 'назад до меню →',
  'howto.page': 'сторінка {n} з {total}',
  'options.title': 'Налаштування',
  'ui.language': 'Мова',
};
